import styles from './Creation.section.module.css'
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import GoBackButton from '@/features/erp/components/buttons/goback/GoBackButton';

import { useProvidersMutations} from '@/features/erp/modules/providers/hooks/providers/useProviders';

import { useCategories} from '../../../../hooks/templates/categories/useCategories';
import { useTags} from '../../../../hooks/templates/tags/useTags';
import { useRequirements } from '../../../../hooks/templates/requirements/useRequirements';

export default function CreationSection() {

    const navigate = useNavigate()

    //Creador del proveedor final
    const { createProvider } = useProvidersMutations()    
    
    
    //Inputs de los formularios
    const [inputName, setInputName] = useState("")
    const [inputNIT, setInputNIT] = useState("")
    const [inputPhone, setInputPhone] = useState("")
    const [inputEmail, setInputEmail] = useState("")
    const [obsoleteCheck, setObsoleteCheck] = useState(false)


    //Categorias
    const { isLoading: categoriesLoading, data: categories } = useCategories()      
    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null)    
    

    //Etiquetas    
    const { data: tags} = useTags(selectedCategoryId)
    const [selectedTagId, setSelectedTagId] = useState<number | null>(null)    

    //Requerimientos        
    const { data: requirements} = useRequirements(selectedCategoryId, selectedTagId)


    //Funcion que valiada si se puede guardar o no el proveedor
    const canSave = inputName && inputNIT && selectedCategoryId

    const handleCreateProvider = () => {
        if(!canSave) return


        createProvider.mutate({
            nit: inputNIT,
            name: inputName,
            categoryId: selectedCategoryId,
            tagId: selectedTagId || undefined,
            email: inputEmail || undefined,
            phone: inputPhone || undefined,
            operating: !obsoleteCheck,
        }, {            
            onSuccess: () => navigate(".."),
            onError: () => {}
        })        
    }

    const handleSelectCategory = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCategoryId(Number(e.currentTarget.value) || null)
    }

    const handleSelectTag = (e: React.ChangeEvent<HTMLSelectElement>) => {
        console.log(Number(e.currentTarget.value))
        setSelectedTagId(Number(e.currentTarget.value) || null)
    }


    useEffect(() => {
        setSelectedTagId(tags?.find(tag => tag.isBase)?.id ?? null)        
    }, [tags])

    return (    
        <div className={styles.section}>
            <div className={styles.topbar}>
                <div className={styles.left}>
                    <GoBackButton />
                    <span>Creacion de nuevo proveedor</span>
                </div>

                <div className={styles.rigth}>                
                    <button type='button' onClick={() => navigate(-1)}>Cancelar</button>
                    <button onClick={handleCreateProvider} className={`${canSave !== undefined ? "": styles.disabled}`} disabled={!canSave}>
                        Guardar
                    </button>
                </div>
            </div>

            <div className={styles.form}>
                <div className={styles.information}>                
                    <span className={styles.title}>Informacion:</span>
                    <div className={styles.labels}>

                        <label className={`${styles.label} ${styles.name}`}>
                            <span>Nombre: *</span>
                            <input type="text" name="" id="" placeholder={"Empresa S.A.S"}
                                   value={inputName}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInputName(e.currentTarget.value)}                                
                            />
                        </label>

                        <label className={`${styles.label} ${styles.nit}`}>
                            <span>NIT: *</span>
                            <input type="text" placeholder={"000000000-0"}
                                   value={inputNIT}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInputNIT(e.currentTarget.value)}
                            />
                        </label>

                        <label className={`${styles.label} ${styles.number}`}>
                            <span>Numero de contacto:</span>
                            <input type="tel" placeholder={"000 000 0000"}
                                   value={inputPhone}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInputPhone(e.currentTarget.value)}
                            />
                        </label>

                        <label className={`${styles.label} ${styles.email}`}>
                            <span>Correo electronico:</span>
                            <input type="email" placeholder={"Empresa@gmail.com"}
                                   value={inputEmail}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInputEmail(e.currentTarget.value)}                                
                            />
                        </label>

                        <label className={`${styles.label} ${styles.operating}`}>
                            <input type="checkbox" name="" 
                                   checked={obsoleteCheck}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => setObsoleteCheck(e.currentTarget.checked) }
                            />
                            <span>Marcar como obsoleto</span>
                        </label>
                    </div>
                </div>            


                <div className={styles.templates}>                
                    <span className={styles.title}>Requerimientos:</span>
                    <div className={styles.lists}>
                        <div className={styles.list}>
                            <span>Categoría: </span>
                            
                            { categoriesLoading && <span>Cargando</span>}
                            
                            <select value={selectedCategoryId ?? ""} onChange={handleSelectCategory}>                                                                    
                                <option value="">
                                    { categories ? categories.length > 0 ? "Sin seleccionar" : "Inexistentes" : ""}
                                </option>
                                { categories?.map((category) => (                                    
                                    <option 
                                        value={category.id}
                                        key={`optioncategory-${category.id}`}
                                    >
                                        {category.name}
                                    </option>                                     
                                ))}                                
                            </select>                                                        
                        </div>
                        <div className={styles.list}>
                            <span>Etiqueta: </span>            
                            { tags &&
                                <select value={selectedTagId ?? ""} onChange={handleSelectTag}>
                                    { tags.map((tag) => {
                                        const isBase = tag.name === "Base";
                                        
                                        return (
                                            <option value={tag.id} key={`optiontype-${tag.id}`}>
                                                {isBase ? "No seleccionada" : tag.name}
                                            </option>
                                        )
                                    })}
                                </select>                                                                                            
                            }                                            
                        </div>
                    </div>

                    <div className={styles.requirements}>                        
                        {
                            requirements?.map((requirement) => (
                                <div key={requirement.id} className={styles.requirement}>
                                    {requirement.documentName}
                                </div>
                            )) 
                        ?? 
                            <div className={styles.nolist}>
                                <span>Selecciona la categoria del tercero para ver sus requerimientos.</span>
                            </div>                            
                        }
                    </div>
                </div>                        
            </div>      
        </div>
    )
}
